<div class="container">
  <h1>QuickBooks OAuth Callback</h1>
  
  <div [ngSwitch]="status">
    <div *ngSwitchCase="'processing'">
      Processing...
    </div>

    <div *ngSwitchCase="'success'">
      <p class="success">Authorization successful!</p>
      <p>Authorization Code:</p>
      <div class="code">{{ code }}</div>
      <p>Realm ID:</p>
      <div class="code">{{ realmId }}</div>
      <p>You can now close this window.</p>
    </div>

    <div *ngSwitchCase="'error'">
      <p class="error" *ngIf="error">Error: {{ error }}</p>
      <p class="error" *ngIf="!error">Invalid callback URL. Missing required parameters.</p>
      <p>Please close this window and try again.</p>
    </div>
  </div>
</div>
